{
  "schemaVersion": 1,
  "base": {
    "fontFamily": "DM Sans, -apple-system, BlinkMacSystemFont, sans-serif",
    "fontScale": 1,
    "radius": 28,
    "touchTarget": 44
  },
  "semantic": {
    "light": {
      "canvas": "#f8fafc",
      "panel": "#ffffff",
      "ink": "#0f172a",
      "muted": "#475569",
      "border": "#cbd5e1",
      "subtle": "#e2e8f0",
      "accent": "#2563eb",
      "accentHover": "#1d4ed8",
      "onAccent": "#ffffff",
      "accentSoft": "#eff6ff",
      "danger": "#b91c1c",
      "dangerSoft": "#fef2f2",
      "focus": "#2563eb",
      "success": "#15803d",
      "warning": "#b45309"
    },
    "dark": {
      "canvas": "#0b1120",
      "panel": "#141e30",
      "ink": "#f1f5f9",
      "muted": "#cbd5e1",
      "border": "#475569",
      "subtle": "#25324a",
      "accent": "#93c5fd",
      "accentHover": "#bfdbfe",
      "onAccent": "#102341",
      "accentSoft": "#172b4b",
      "danger": "#fca5a5",
      "dangerSoft": "#3b1923",
      "focus": "#93c5fd",
      "success": "#86efac",
      "warning": "#fcd34d"
    }
  },
  "component": {
    "button": {
      "weight": 600,
      "gap": 8,
      "disabledOpacity": 0.48,
      "borderWidth": 1,
      "focusWidth": 3,
      "focusOffset": 3,
      "sizes": {
        "xs": {
          "height": 28,
          "font": 12,
          "icon": 14,
          "padding": 8,
          "paddingBlock": 4
        },
        "sm": {
          "height": 36,
          "font": 13,
          "icon": 16,
          "padding": 12,
          "paddingBlock": 6
        },
        "md": {
          "height": 44,
          "font": 14,
          "icon": 16,
          "padding": 16,
          "paddingBlock": 6
        },
        "lg": {
          "height": 50,
          "font": 15,
          "icon": 18,
          "padding": 20,
          "paddingBlock": 6
        },
        "xl": {
          "height": 56,
          "font": 16,
          "icon": 20,
          "padding": 24,
          "paddingBlock": 6
        }
      },
      "lineHeight": 1.35,
      "activeBrightness": 0.92,
      "spinnerStroke": 2,
      "pillRadius": 999
    },
    "input": {
      "sizes": {
        "xs": {
          "height": 28,
          "padding": 8,
          "font": 12
        },
        "sm": {
          "height": 36,
          "padding": 12,
          "font": 13
        },
        "md": {
          "height": 44,
          "padding": 16,
          "font": 14
        },
        "lg": {
          "height": 50,
          "padding": 20,
          "font": 15
        },
        "xl": {
          "height": 56,
          "padding": 24,
          "font": 16
        }
      },
      "focusColor": "var(--accent)"
    },
    "switch": {
      "sizes": {
        "default": {
          "width": 42,
          "height": 24,
          "knobWidth": 18,
          "knobHeight": 18,
          "inset": 3
        },
        "mini": {
          "width": 36,
          "height": 16,
          "knobWidth": 21,
          "knobHeight": 13,
          "inset": 1.5
        },
        "small": {
          "width": 44,
          "height": 20,
          "knobWidth": 26,
          "knobHeight": 16,
          "inset": 2
        },
        "regular": {
          "width": 54,
          "height": 24,
          "knobWidth": 32,
          "knobHeight": 20,
          "inset": 2
        },
        "large": {
          "width": 64,
          "height": 28,
          "knobWidth": 38,
          "knobHeight": 24,
          "inset": 2
        },
        "xlarge": {
          "width": 80,
          "height": 36,
          "knobWidth": 47,
          "knobHeight": 30,
          "inset": 3
        }
      },
      "pressStretch": 5
    },
    "checkbox": {
      "sizes": {
        "sm": 16,
        "md": 18,
        "lg": 22
      },
      "markRadius": 5
    }
  },
  "motion": {
    "duration": {
      "instant": 0.12,
      "fast": 0.16,
      "exit": 0.18,
      "standard": 0.24,
      "considered": 0.48,
      "spinner": 0.7,
      "themeReveal": 0.6
    },
    "ease": {
      "enter": [
        0.16,
        1,
        0.3,
        1
      ],
      "exit": [
        0.7,
        0,
        0.84,
        0
      ],
      "standard": [
        0.22,
        1,
        0.36,
        1
      ],
      "inOut": [
        0.65,
        0,
        0.35,
        1
      ],
      "themeReveal": [
        0.22,
        1,
        0.36,
        1
      ]
    },
    "spring": {
      "snappy": {
        "type": "spring",
        "visualDuration": 0.26,
        "bounce": 0.12
      },
      "morph": {
        "type": "spring",
        "visualDuration": 0.42,
        "bounce": 0.16
      },
      "smooth": {
        "type": "spring",
        "visualDuration": 0.4,
        "bounce": 0
      },
      "responsive": {
        "type": "spring",
        "stiffness": 520,
        "damping": 38
      },
      "gentle": {
        "type": "spring",
        "stiffness": 340,
        "damping": 34
      }
    },
    "blur": {
      "subtle": 2,
      "soft": 4,
      "text": 8
    },
    "button": {
      "pressWide": 0.985,
      "pressIcon": 0.96,
      "press": 0.97,
      "wideThreshold": 220,
      "iconThreshold": 48,
      "textEnterY": 4,
      "textExitY": -3,
      "iconScale": 0.6,
      "loaderExitScale": 0.8,
      "morphWindowMs": 700
    },
    "stagger": {
      "char": 0.016,
      "word": 0.04,
      "line": 0.08,
      "item": 0.035
    }
  },
  "presets": {
    "violet": {
      "light": {
        "accent": "#6d28d9",
        "focus": "#6d28d9",
        "accentHover": "#5b21b6",
        "accentSoft": "#f5f3ff"
      },
      "dark": {
        "accent": "#c4b5fd",
        "focus": "#c4b5fd",
        "accentHover": "#ddd6fe",
        "accentSoft": "#292047"
      }
    }
  },
  "arcAliases": {
    "--arc-accent": "var(--accent)",
    "--arc-accent-foreground": "var(--on-accent)",
    "--arc-accent-strong": "var(--accent-hover)",
    "--arc-background": "var(--panel)",
    "--arc-border": "var(--border)",
    "--arc-border-strong": "var(--border)",
    "--arc-border-subtle": "var(--border)",
    "--arc-control-on": "var(--accent)",
    "--arc-danger": "var(--danger)",
    "--arc-focus-ring": "var(--focus)",
    "--arc-font-body": "var(--font-family)",
    "--arc-foreground": "var(--ink)",
    "--arc-radius-control": "var(--radius)",
    "--arc-radius-panel": "var(--radius)",
    "--arc-radius-pill": "var(--radius)",
    "--arc-success": "var(--success)",
    "--arc-surface": "var(--panel)",
    "--arc-surface-muted": "var(--subtle)",
    "--arc-surface-raised": "var(--panel)",
    "--arc-text-muted": "var(--muted)",
    "--arc-text-secondary": "var(--muted)",
    "--arc-control-height-sm": "var(--button-sm-height)",
    "--arc-control-height-md": "var(--button-md-height)",
    "--arc-control-height-lg": "var(--button-lg-height)",
    "--arc-duration-instant": "var(--duration-instant)",
    "--arc-duration-fast": "var(--duration-fast)",
    "--arc-duration-standard": "var(--duration-standard)",
    "--arc-ease-enter": "var(--ease-enter)",
    "--arc-ease-standard": "var(--ease-standard)",
    "--arc-ease-in-out": "var(--ease-inOut)",
    "--arc-ease-spring": "var(--ease-standard)",
    "--arc-duration-spring": "var(--duration-considered)",
    "--arc-leading-body": "var(--button-line-height)",
    "--arc-tracking-body": "-.01em",
    "--arc-text-xs": "calc(var(--button-xs-font) * var(--font-scale))",
    "--arc-text-sm": "calc(var(--button-md-font) * var(--font-scale))",
    "--arc-shadow-resting": "0 1px 2px color-mix(in srgb, var(--ink) 6%, transparent)",
    "--arc-shadow-raised": "0 6px 18px color-mix(in srgb, var(--ink) 10%, transparent)",
    "--arc-shadow-floating": "0 20px 48px color-mix(in srgb, var(--ink) 14%, transparent)",
    "--arc-space-1": "0.25rem",
    "--arc-space-2": "0.5rem",
    "--arc-space-3": "0.75rem",
    "--arc-space-4": "1.0rem",
    "--arc-space-5": "1.25rem",
    "--arc-accent-subtle": "var(--accent-soft)",
    "--arc-duration-considered": "var(--duration-considered)",
    "--arc-font-display": "var(--font-family)",
    "--arc-space-6": "24px",
    "--arc-space-8": "32px",
    "--arc-text-2xl": "24px",
    "--arc-text-3xl": "calc(36px * var(--font-scale))",
    "--arc-text-base": "16px",
    "--arc-text-lg": "18px",
    "--arc-text-xl": "20px",
    "--arc-tracking-display": "-.02em",
    "--arc-warning": "var(--warning)",
    "--arc-menu-group-size": "11px",
    "--arc-menu-group-weight": "500",
    "--arc-menu-group-color": "var(--muted)",
    "--arc-menu-group-tracking": ".09em",
    "--arc-menu-group-gap": "12px",
    "--arc-control-glyph": "var(--on-accent)",
    "--arc-control-track": "var(--subtle)",
    "--arc-control-track-hover": "color-mix(in srgb, var(--ink) 22%, var(--panel))",
    "--arc-control-thumb": "var(--panel)",
    "--arc-control-thumb-on": "var(--on-accent)",
    "--arc-control-thumb-shadow": "0 1px 3px color-mix(in srgb, var(--ink) 16%, transparent)",
    "--arc-control-fill": "var(--accent)",
    "--arc-nav-row-height": "40px",
    "--arc-nav-icon-size": "18px",
    "--arc-dialog-compact": "400px",
    "--arc-dialog-default": "520px",
    "--arc-dialog-wide": "720px",
    "--arc-dialog-padding": "28px",
    "--arc-dialog-title-size": "calc(20px * var(--font-scale))",
    "--arc-dialog-description-size": "calc(13px * var(--font-scale))",
    "--arc-dialog-description-color": "var(--muted)",
    "--arc-dialog-section-gap": "24px",
    "--arc-input-border-hover": "color-mix(in srgb, var(--border) 70%, var(--muted))",
    "--arc-text-4xl": "calc(36px * var(--font-scale))",
    "--arc-text-5xl": "calc(48px * var(--font-scale))",
    "--arc-leading-display": "1.1",
    "--identity-avatar-radius": "50%",
    "--identity-avatar-sm": "28px",
    "--identity-avatar-md": "36px",
    "--identity-avatar-lg": "48px",
    "--identity-avatar-xl": "88px",
    "--arc-overlay-background": "oklch(10% 0 0 / .46)",
    "--arc-overlay-blur": "7px",
    "--arc-radius-surface": "var(--radius)",
    "--arc-space-12": "48px",
    "--arc-font-mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    "--arc-ease-exit": "var(--ease-exit)",
    "--arc-gradient-from": "var(--accent-soft)",
    "--arc-gradient-to": "var(--arc-series-2)",
    "--arc-focus-width": "1px",
    "--arc-focus-offset": "2px",
    "--arc-space-10": "2.5rem",
    "--arc-space-16": "4.0rem",
    "--arc-space-20": "5.0rem",
    "--arc-space-24": "6.0rem"
  },
  "chartPalette": {
    "fallback": {
      "--arc-series-1": "var(--arc-accent)",
      "--arc-series-2": "#7128a5",
      "--arc-series-3": "#e58f00",
      "--arc-series-4": "#009e84"
    },
    "light": {
      "--arc-series-1": "oklch(from var(--arc-accent) calc(l * sign(max(c - .02, 0)) + .58 * (1 - sign(max(c - .02, 0)))) calc(c * sign(max(c - .02, 0)) + .15 * (1 - sign(max(c - .02, 0)))) calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0)))))",
      "--arc-series-2": "oklch(from var(--arc-accent) clamp(.45, l * sign(max(c - .02, 0)) + .58 * (1 - sign(max(c - .02, 0))) - 0.25, .76) .19 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 57))",
      "--arc-series-3": "oklch(from var(--arc-accent) clamp(.45, l * sign(max(c - .02, 0)) + .58 * (1 - sign(max(c - .02, 0))) + 0.14, .76) .18 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 184))",
      "--arc-series-4": "oklch(from var(--arc-accent) clamp(.45, l * sign(max(c - .02, 0)) + .58 * (1 - sign(max(c - .02, 0))), .76) .21 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 292))"
    },
    "dark": {
      "--arc-series-1": "oklch(from var(--arc-accent) calc(l * sign(max(c - .02, 0)) + .73 * (1 - sign(max(c - .02, 0)))) calc(c * sign(max(c - .02, 0)) + .15 * (1 - sign(max(c - .02, 0)))) calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0)))))",
      "--arc-series-2": "oklch(from var(--arc-accent) clamp(.485, l * sign(max(c - .02, 0)) + .73 * (1 - sign(max(c - .02, 0))) - 0.19, .665) .21 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 66))",
      "--arc-series-3": "oklch(from var(--arc-accent) clamp(.485, l * sign(max(c - .02, 0)) + .73 * (1 - sign(max(c - .02, 0))) + 0.02, .665) .21 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 175))",
      "--arc-series-4": "oklch(from var(--arc-accent) clamp(.485, l * sign(max(c - .02, 0)) + .73 * (1 - sign(max(c - .02, 0))) - 0.1, .665) .18 calc(h * sign(max(c - .02, 0)) + 250 * (1 - sign(max(c - .02, 0))) + 270))"
    }
  }
}
